package com.eladfinish.bible.contest.screens.americanQuestions.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

/**
 * Developed by
 * @author Elad Finish
 */

@Serializable
data class AmericanQuestionSheetEntry(
    @SerialName("שאלה") val question: String,
    @SerialName("תשובה-א") val answerA: String,
    @SerialName("תשובה-ב") val answerB: String,
    @SerialName("תשובה-ג") val answerC: String,
    @SerialName("תשובה-ד") val answerD: String,
    @SerialName("נכונה") val correct: String,
    @SerialName("ספר") val book: String,
    @SerialName("פרק") val chapter: String,
    @SerialName("שם-פרטי") val firstName: String,
    @SerialName("שם-משפחה") val lastName: String,
) {
    val options: List<String> get() = listOf(answerA, answerB, answerC, answerD)

    /** [correct] is the correct option's letter (see [OPTION_LETTERS]); anything else counts as the first. */
    val correctIndex: Int get() = OPTION_LETTERS.indexOf(correct).coerceAtLeast(0)

    val correctOption: String get() = options[correctIndex]

    companion object {
        /** The options' letters, in order. */
        const val OPTION_LETTERS = "אבגד"
    }

    /** The book's name as in BibleCatalog (the sheet sometimes writes e.g. "שמואל א'"). */
    val bookName: String get() = book.replace("'", "")
}

/** The questions sheet's rows as entries; rows missing columns are skipped. */
fun List<List<String>>.toAmericanQuestionEntries(): List<AmericanQuestionSheetEntry> =
    mapNotNull { row ->
        if (row.size < 10) return@mapNotNull null
        AmericanQuestionSheetEntry(
            question = row[0],
            answerA = row[1],
            answerB = row[2],
            answerC = row[3],
            answerD = row[4],
            correct = row[5],
            book = row[6],
            chapter = row[7],
            firstName = row[8],
            lastName = row[9],
        )
    }
